import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { setworkdetails } from "../../actions/setworkdetailsaction";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";

const EditWorkDetails = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [vendorCode, setVendorCode] = useState("");
  const [vendorCodeError, setVendorCodeError] = useState("");
  const [workDetails, setWorkDetails] = useState({
    vendorId: props.workdetails.vendorId || "",
    opening_time: props.workdetails.opening_time || "",
    closing_time: props.workdetails.closing_time || "",
    off_day: props.workdetails.off_day || "",
  });

  useEffect(() => {
    Service.getAllData("vendors").then((list) => {
      if (list.length > 0) {
        setVendors(list);
        const found = list.find((v) => v.uid === props.workdetails.vendorId);
        if (found) setVendorCode(found.vendorCode || "");
      }
    });
  }, [props.workdetails.vendorId]);

  const handleVendorCodeBlur = () => {
    if (vendorCode) {
      const found = vendors.find((v) => v.vendorCode === vendorCode);
      if (found) {
        setWorkDetails((prev) => ({ ...prev, vendorId: found.uid }));
        setVendorCodeError("");
      } else {
        setVendorCodeError("Vendor code not found");
      }
    }
  };

  const onEdit = (e) => {
    const { name, value } = e.target;
    setWorkDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!workDetails.vendorId) {
      setVendorCodeError("Please enter a valid vendor code");
      return;
    }
    setIsLoading(true);
    const res = await Service.updateData(
      workDetails,
      "workDetails",
      props.workdetails.workDetailsId
    );
    if (res === "success") {
      setIsLoading(false);
      setOpenAlertDialog(true);
      props.setOnWorkDetails({
        ...workDetails,
        workDetailsId: props.workdetails.workDetailsId,
      });
    } else {
      setIsLoading(false);
      setOpenErrorDialog(true);
    }
  };

  return isLoading ? (
    <div style={{ textAlign: "center", padding: 40 }}>
      <i
        className="fas fa-spinner fa-pulse fa-4x"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      ></i>
    </div>
  ) : (
    <div style={{ padding: "24px", maxWidth: 600, margin: "0 auto" }}>
      <AlertDialogBox
        openDailog={openAlertDialog}
        onSetOpenDailog={() => setOpenAlertDialog(false)}
        title="Updated"
        des="Work details successfully updated"
      />
      <ErorrDialogBox
        openDailog={openErrorDialog}
        onSetOpenDailog={() => setOpenErrorDialog(false)}
        title="Error"
        des="Something went wrong. Try again"
      />

      <div className="topheader" style={{ marginBottom: 16 }}>
        <ul style={{ listStyle: "none", display: "flex", alignItems: "center", padding: 0, gap: 10 }}>
          <li><i className="fa fa-arrow-circle-o-right fa-2x" aria-hidden="true"></i></li>
          <li><h5>Edit Work Details</h5></li>
        </ul>
      </div>
      <hr />

      <form onSubmit={handleSubmit}>
        {/* Vendor Code */}
        <div className="form-group">
          <label>Vendor Code <span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter vendor code"
            value={vendorCode}
            onChange={(e) => setVendorCode(e.target.value)}
            onBlur={handleVendorCodeBlur}
            required
          />
          {vendorCodeError && <small style={{ color: "red" }}>{vendorCodeError}</small>}
          {workDetails.vendorId && !vendorCodeError && (
            <small style={{ color: "green" }}>
              {vendors.find((v) => v.uid === workDetails.vendorId)?.salonName || "Vendor found"}
            </small>
          )}
        </div>

        {/* Opening Time */}
        <div className="form-group">
          <label>Opening Time <span style={{ color: "red" }}>*</span></label>
          <input
            name="opening_time"
            type="time"
            className="form-control"
            value={workDetails.opening_time}
            onChange={onEdit}
            required
          />
        </div>

        {/* Closing Time */}
        <div className="form-group">
          <label>Closing Time <span style={{ color: "red" }}>*</span></label>
          <input
            name="closing_time"
            type="time"
            className="form-control"
            value={workDetails.closing_time}
            onChange={onEdit}
            required
          />
        </div>

        {/* Off Day */}
        <div className="form-group">
          <label>Off Day <span style={{ color: "red" }}>*</span></label>
          <select
            name="off_day"
            className="form-control"
            value={workDetails.off_day}
            onChange={onEdit}
            required
          >
            <option value="">Select Off Day</option>
            <option value="No Off Day">No Off Day</option>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
            <option value="Sunday">Sunday</option>
          </select>
        </div>

        <button type="submit" className="btn btn-primary">Update</button>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  workdetails: state.workdetails || {},
});

const mapDispatchToProps = (dispatch) => ({
  setOnWorkDetails: (p) => dispatch(setworkdetails(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditWorkDetails);
